import { render, staticRenderFns } from "./headerbell.vue?vue&type=template&id=cfac30f0&scoped=true&"
import script from "./headerbell.vue?vue&type=script&lang=js&"
export * from "./headerbell.vue?vue&type=script&lang=js&"
import style0 from "./headerbell.vue?vue&type=style&index=0&id=cfac30f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfac30f0",
  null
  
)

export default component.exports